import { useEffect, useState } from "react";

import { ATTENDEE_TYPE_NAME_ATHLETE, ROLE_TYPE_NAME_ATHLETE } from "../../../utils/NTGroupConstants";

import useNTGroupData from "../../../../../state/nationalTeamGroup/UseNTGroupData";
import useNTGroupRoleTypesData from "../../../../../state/nationalTeamGroupRoleTypes/UseNTGroupRoleTypesData";
import useNTGroupAttendeeTypesData from "../../../../../state/nationalTeamGroupAttendeeTypes/UseNTGroupAttendeeTypesData";

const useNTGroupAddAthletesFormGrid = (gridData, onSubmitFormCallback) => {
  const { onNTGroupsError } = useNTGroupData();
  const { nationalTeamGroupRoleTypesState, getNTGroupRoleTypes } = useNTGroupRoleTypesData();
  const { nationalTeamGroupAttendeeTypesState, getNTGroupAttendeeTypes } = useNTGroupAttendeeTypesData();
  const [formGridState, setFormGridState] = useState([]);

  const onAddSelectedClicked = (event, selectedIds) => {
    try {
      event?.preventDefault();

      const groupAthletes = [];

      for (const groupAthleteFormObj of formGridState) {
        if (selectedIds.includes(groupAthleteFormObj.personNationalTeamGroupId)) {
          const athleteAttendeeType = nationalTeamGroupAttendeeTypesState.options.find((x) => x.name === ATTENDEE_TYPE_NAME_ATHLETE);
          const athleteRoleType = nationalTeamGroupRoleTypesState.options.find((x) => x.name === ROLE_TYPE_NAME_ATHLETE);

          groupAthletes.push({
            personNationalTeamGroupId: groupAthleteFormObj.personNationalTeamGroupId,
            groupAttendeeTypeId: athleteAttendeeType.id,
            groupRoleTypeId: athleteRoleType.id,
            removeFromGroup: false,
            isConfirmed: true,
            inviteStatus: null
          });
        } else {
          groupAthletes.push({
            personNationalTeamGroupId: groupAthleteFormObj.personNationalTeamGroupId,
            groupAttendeeTypeId: null,
            groupRoleTypeId: null,
            removeFromGroup: true,
            isConfirmed: false,
            inviteStatus: null
          });
        }
      }

      onSubmitFormCallback(groupAthletes);
    } catch (e) {
      onNTGroupsError(e);
    }
  };

  useEffect(() => {
    try {
      const newFormGridState = [];

      for (const groupAthleteObj of gridData) {
        const newGroupAthleteFormObj = createGroupAthleteFormObj(groupAthleteObj);

        newFormGridState.push(newGroupAthleteFormObj);
      }

      setFormGridState(newFormGridState);
    } catch (e) {
      onNTGroupsError(e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gridData]);

  useEffect(() => {
    if (nationalTeamGroupRoleTypesState.areOptionsLoaded !== true) {
      const getNTGroupRoleTypesPromise = getNTGroupRoleTypes();

      if (getNTGroupRoleTypesPromise ?? false) {
        getNTGroupRoleTypesPromise.catch((e) => {
          onNTGroupsError(e);
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nationalTeamGroupRoleTypesState.areOptionsLoaded]);

  useEffect(() => {
    if (nationalTeamGroupAttendeeTypesState.areOptionsLoaded !== true) {
      const getNTGroupAttendeeTypesPromise = getNTGroupAttendeeTypes();

      if (getNTGroupAttendeeTypesPromise ?? false) {
        getNTGroupAttendeeTypesPromise.catch((e) => {
          onNTGroupsError(e);
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nationalTeamGroupAttendeeTypesState.areOptionsLoaded]);

  function createGroupAthleteFormObj(groupAthleteObj) {
    return {
      personNationalTeamGroupId: groupAthleteObj.personNationalTeamGroupId,
      personId: groupAthleteObj.personId,
      groupAthleteName: `${groupAthleteObj?.preferredName || groupAthleteObj?.firstName} ${groupAthleteObj?.lastName}`,
      memberId: groupAthleteObj.memberId,
      lastName: groupAthleteObj.lastName,
      events: Array.isArray(groupAthleteObj.personNationalTeamGroupEvent) ? groupAthleteObj.personNationalTeamGroupEvent : []
    };
  }

  return {
    formGridState,
    onAddSelectedClicked
  };
};

export default useNTGroupAddAthletesFormGrid;